// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".crd-teaser-text-layer__button{transition:opacity .3s ease-in-out!important}", ""]);
// Exports
module.exports = exports;
